



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import DigitalCurrency6AccountUserProfilePicture from '../../basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'

import UserInterface6HtmlReader from '../user-interface-6-html-reader.vue'

// import * as echarts from 'echarts'
import VChart from 'vue-echarts' // refers to components/ECharts.vue in webpack
// import 'echarts/lib/chart/line'

import { use } from 'echarts/core'

// import ECharts modules manually to reduce bundle size
import {
  CanvasRenderer
} from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components'

import { getBarChartOptions } from './service-for-vue-echarts-algorithms/vue-echarts-algorithms-1-get-bar-chart-options'

import {
  itemTypeAccount,
  itemTypeTransaction
} from '../service-for-data-structures/data-structures-1-file-system-data-structure'
import { isValidHttpUrl } from '../service-for-algorithms/algorithms-1-is-valid-http-url'

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  DataZoomComponent
])


@Component({
  components: {
    VChart,
    DigitalCurrency6AccountUserProfilePicture,
    UserInterface6HtmlReader
  }
})
class FolderItemView2GraphView extends Vue {

  @Prop({ default: '' }) graphType?: string
  @Prop({ default: () => { return {} } }) graphData?: any

  GRAPH_TYPE_BAR_GRAPH = 'bar-graph'
  GRAPH_TYPE_DATA_TABLE = 'data-table'

  ITEM_TYPE_ACCOUNT = itemTypeAccount
  ITEM_TYPE_TRANSACTION = itemTypeTransaction

  dataTableDataList: any[] = []

  dataTableSearchTextFieldLabel: string = ''
  dataTableSearchText: string = ''

  dataTablePage: number = 1
  dataTablePageCount: number = 0
  dataTableItemsPerPage: number = 5

  dataTableDataHasOpeningIcon: boolean = false
  dataTableDataHasClosingActionButton: boolean = false
  dataTableDataPropertyHtmlItemRecipientList: string[] = []

  dataTableShowSelectCheckbox: boolean = false
  dataTableSelectedItems: any[] = []
  dataTableSelectItemEventListener: any = () => false

  dataTableShowSettingsButton: boolean = false
  dataTableSettingsButtonFunction: any = () => false
  dataTableActionButtonList: Array<{
    iconImageId?: string
    text?: string
    cssClass: any
    evaluateFunction: any
  }> = []

  isValidHttpUrl = isValidHttpUrl

  get graphOptions () {
    switch (this.graphType) {
      case this.GRAPH_TYPE_BAR_GRAPH:
        return Object.assign({}, getBarChartOptions({
          xAxisLabel: this.graphData.xAxisLabel,
          yAxisLabel: this.graphData.yAxisLabel,
          dateDataList: this.graphData.dateList.map((date: any) => new Date(date)),
          dataList: this.graphData.dataList
        }))
        break
    }
    return {}
  }

  get dataTableData (): {
    headerList: Array<{
      text?: string
      value: string
      align?: string
      sortable?: boolean
    }>
    dataList: any[]
  } {
    const hasOpeningIcon = this.graphData.hasOpeningIcon || false
    const hasClosingActionButton = this.graphData.hasClosingActionButton || false

    this.dataTableDataHasOpeningIcon = hasOpeningIcon
    this.dataTableDataHasClosingActionButton = hasClosingActionButton
    this.dataTableDataPropertyHtmlItemRecipientList = this.graphData.propertyHtmlItemRecipientList || []
    this.dataTableSearchTextFieldLabel = this.graphData.dataTableSearchTextFieldLabel || ''
    this.dataTableShowSettingsButton = this.graphData.dataTableShowSettingsButton
    this.dataTableSettingsButtonFunction = this.graphData.dataTableSettingsButtonFunction || (() => false)
    this.dataTableShowSelectCheckbox = this.graphData.dataTableShowSelectCheckbox
    this.dataTableSelectItemEventListener = this.graphData.dataTableSelectItemEventListener || (() => false)
    this.dataTableActionButtonList = this.graphData.dataTableActionButtonList || []

    let dataTableHeaderList = this.graphData.dataTableHeaderList || []

    // Add opening icon header item
    if (hasOpeningIcon) {
      dataTableHeaderList = [{
        value: 'itemIconImageUrl',
        align: 'start',
        sortable: false
      }, ...dataTableHeaderList]
    }

    // Add closing action button item
    if (hasClosingActionButton) {
      dataTableHeaderList = [...dataTableHeaderList, {
        value: 'closingActionButtonText',
        sortable: false
      }]
    }

    dataTableHeaderList.push({
      text: '',
      value: 'itemDataAsString',
      class: ['hide-header'],
      width: 0
    })

    const dataTableDataList = this.graphData.dataTableDataList || []
    this.dataTableDataList = dataTableDataList

    this.resetDataTableSelectedItemList()

    return {
      headerList: dataTableHeaderList,
      dataList: dataTableDataList
    }

  }

  async sendSelectedItemList () {
    await new Promise((resolve) => setTimeout(resolve, 0))
    this.dataTableSelectItemEventListener(this.dataTableSelectedItems)
  }

  resetDataTableSelectedItemList () {
    const currentItemList = this.dataTableDataList

    let newSelectedItemList = []

    for (let i = 0;i < this.dataTableSelectedItems.length; i++) {
      const selectedItem = this.dataTableSelectedItems[i]
      const isItemInList = currentItemList.filter((item: any) => {
        return item.itemId === selectedItem.itemId
      })[0]
      if (!isItemInList) {
        continue
      }
      newSelectedItemList.push(selectedItem)
    }

    this.dataTableSelectedItems = newSelectedItemList
  }

  evaluateClosingActionButtonFunction (item: any) {

    if (item.closingActionButtonFunction) {
      item.closingActionButtonFunction(item.itemId)
    }

    if (item.openFolderOrFileItem) {
      this.$emit('openFolderOrFileItem', item)
    }
  }

  @Watch('dataTablePage') onUpdateDataTablePage () {
    this.scrollToTop()
    this.$emit('graphViewDataTablePageData', {
      page: this.dataTablePage,
      pageCount: this.dataTablePageCount,
      itemsPerPage: this.dataTableItemsPerPage
    })
  }

  @Watch('dataTableItemsPerPage') onUpdateDataTableItemsPerPage () {
    this.$emit('graphViewDataTablePageData', {
      page: this.dataTablePage,
      pageCount: this.dataTablePageCount,
      itemsPerPage: this.dataTableItemsPerPage
    })
  }

  updateDataTablePageData (pageDataId: string, pageDataValue: any) {
    if (pageDataId === 'dataTablePage') {
      this.dataTablePage = pageDataValue
    } else if (pageDataId === 'dataTablePageCount') {
      this.dataTablePageCount = pageDataValue
    } else if (pageDataId === 'dataTableItemsPerPage') {
      this.dataTableItemsPerPage = pageDataValue
    }

    this.$emit('graphViewDataTablePageData', {
      page: this.dataTablePage,
      pageCount: this.dataTablePageCount,
      itemsPerPage: this.dataTableItemsPerPage
    })
  }

  scrollToTop () {
    const headerElement = this.$refs['folder-item-view-2-graph-view'] as HTMLElement
    if (!headerElement) {
      return
    }
    const headerElementTopPosition = headerElement.getBoundingClientRect().top + window.scrollY
    window.scrollTo({ top: headerElementTopPosition - 200 })
  }

}

export default FolderItemView2GraphView

